import { useDeploymentSetConfig } from './useDeploymentSetConfig'

export function usePricesSettings() {
  const { v3BackendLrtUrl } = useDeploymentSetConfig()

  return {
    pricesBaseURL: v3BackendLrtUrl,
  }
}
